import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'general'
})
export class GeneralPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return null;
  }

}


/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
*/
@Pipe({name: 'ddMMM'})
export class ddMMMPipe implements PipeTransform {
  transform(value: string): string {
    let d = new Date(value);
    return d.toLocaleDateString('it-IT', {day:'2-digit', month:'short'});
  }
}

@Pipe({name: 'DDDdd'})
export class DDDddPipe implements PipeTransform {
  transform(value: string): string {
    let d = new Date(value);
    return d.toLocaleDateString('it-IT', {weekday:'short', day:'2-digit' });
  }
}

@Pipe({name: 'classesToString'})
export class classesToStringPipe implements PipeTransform {
  transform(value: object): string {
    var classesString = '';
    for (var h in value) {
      classesString = classesString +' '+h+' '+value[h]+', '
    }
    if (classesString.length > 2) {classesString = classesString.substr(0,classesString.length-2)}
    return classesString
  }
}


// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/general.pipe.ts